import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08556660"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "container",
  style: {"font-family":"'YouSheBiaoTiHei'","color":"#fff","font-size":"min(2.5vh,1.375vw)"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"none"} }, [
  /*#__PURE__*/_createElementVNode("div", { id: "myIcon" })
], -1))
const _hoisted_3 = { class: "chartTitle" }
const _hoisted_4 = { class: "chartContainer" }
const _hoisted_5 = { class: "first" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"linear-gradient(180deg, rgba(43,165,255,0) 0%, rgba(11,97,159,0.42) 47%, rgba(43,165,255,0) 100%)"} }, " 项目总数", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "second" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"linear-gradient(180deg, rgba(43,165,255,0) 0%, rgba(11,97,159,0.42) 47%, rgba(43,165,255,0) 100%)"} }, " 参与项目总数", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "third" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"linear-gradient(180deg, rgba(43,165,255,0) 0%, rgba(11,97,159,0.42) 47%, rgba(43,165,255,0) 100%)"} }, " 发起项目总数", -1))

import AMapLoader from "@amap/amap-jsapi-loader";
import { onActivated, onMounted, watch } from "vue";
import javaapi from "../../service/javaapi";
import gauge from "@/components/gauge.vue";
import { ref } from "vue";
import { useRouter,useRoute } from 'vue-router';
import * as echarts from 'echarts';

type EChartsOption = echarts.EChartsOption

export default /*#__PURE__*/_defineComponent({
  __name: 'GISPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()
let map
let infoWindow
let lastPosition
const projectInfo = ref([
  {
    "number": 0,
    "ongoing_num": 0,
    "paused_num": 0,
    "completed_num": 0,
    "completed_num_rate": 0
  },
  {
    "number": 0,
    "ongoing_num": 0,
    "paused_num": 0,
    "completed_num": 0,
    "completed_num_rate": 0
  },
  {
    "number": 0,
    "ongoing_num": 0,
    "paused_num": 0,
    "completed_num": 0,
    "completed_num_rate": 0
  }
])

const clickChart = async () => {
  router.push({
    name: 'CityChart',
    query:{
      id: localStorage.getItem("organization_id"),
      name:organization_name.value
    }
  });
}
const organization_name = ref(
  localStorage.getItem("organization_name")
)
const px = ref(Math.min(window.outerHeight,window.outerWidth) * 0.3 * (1 / 3))
window.addEventListener('resize',()=>{
    px.value = Math.min(window.outerHeight,window.outerWidth) * 0.3 * (1 / 3)
})

const init = async (percentage:number) => {
  var chartDom = document.getElementById('main12')!;
  var myChart = echarts.init(chartDom);
  var option: EChartsOption;
  const gaugeData = [
    {
      value: 20,
      name: 'Perfect',
      detail: {
        valueAnimation: true,
        offsetCenter: ['0%', '0%']
      }
    }
  ];
  option = {
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false
        },
        radius: px.value / 2 -2,
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {

            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
              // 四个数字分别对应 数组中颜色的开始位置，分别为 右，下，左，上。例如（1,0,0,0 ）代表从右边开始渐
              // 变。offset取值为0~1，0代表开始时的颜色，1代表结束时的颜色，柱子表现为这两种颜色的渐变。
              offset: 0,
              color: '#2B8EF3'
            }, {
              offset: 1,
              color: '#47E4E5'
            }]),
          }
        },
        axisLine: {
          lineStyle: {
            width: 10,
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
        },
        data: gaugeData,
        title: {
          show: false
        },
        detail: {
          fontSize: px.value / 4,
          color: '#fff',
          formatter: '{value}%',

        }
      }
    ]
  };
  gaugeData[0].value = percentage;
  myChart.setOption<EChartsOption>(option);
}

const initMap = async () => {
  // console.log("初始化")
  var selector1 = {
    OrganizationId: localStorage.getItem("organization_id"),
    user_id: parseInt(<string>localStorage.getItem("user_id")),
  }
  const projectInfoList = await javaapi.list({ entity: "project", interface: "getProjectsInfByOrganizationId" }, selector1);
  projectInfo.value[0].number = projectInfoList.projectDTOes.length;

  projectInfoList.projectDTOes.forEach((val: any, idx: any, arr: any) => {
    if (val.status == "进行中") {
      projectInfo.value[0].ongoing_num++;
      if (val.isOrganizationDistribute == 0) {
        projectInfo.value[2].ongoing_num++;
      } else {
        projectInfo.value[1].ongoing_num++;
      }

    } else if (val.status == "已暂停") {
      projectInfo.value[0].paused_num++;
      if (val.isOrganizationDistribute == 0) {
        projectInfo.value[2].paused_num++;
      } else {
        projectInfo.value[1].paused_num++;
      }
    } else if (val.status == "已完成") {
      projectInfo.value[0].completed_num++;
      if (val.isOrganizationDistribute == 0) {
        projectInfo.value[2].completed_num++;
      } else {
        projectInfo.value[1].completed_num++;
      }
    }
    projectInfo.value[1].number = projectInfo.value[1].completed_num + projectInfo.value[1].paused_num + projectInfo.value[1].ongoing_num;
    projectInfo.value[2].number = projectInfo.value[0].number - projectInfo.value[1].number;
    projectInfo.value.forEach((val: any, idx: any, arr: any) => {
      if (val.completed_num == 0) {
        val.completed_num_rate = 0;
      } else {
        val.completed_num_rate = val.completed_num / val.number * 100;
      }
    })

  })
  var selector2 = {
    OrganizationId: localStorage.getItem("organization_id")
  }
  const orglist = await javaapi.list({ entity: "organization", interface: "getSubOrganizationById" }, selector2);

  AMapLoader.load({
    key: "6bbe90d8254c3cc452e1346bf9957d2e", // 开发者Key
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [], // 需要使用的的插件列表
  })
    .then((AMap) => {
      map = new AMap.Map("container", {
        //设置地图容器id
        viewMode: "2D", //地图模式
        zoom: 8, //初始化地图级别
        center: orglist.subOrganizationsDTOes.length==0?[Number(localStorage.getItem("longitude")),Number(localStorage.getItem("latitude"))]:[Number(orglist.subOrganizationsDTOes[0].longitude), Number(orglist.subOrganizationsDTOes[0].latitude)], //初始化地图中心点位置
        mapStyle: "amap://styles/darkblue",
      });
      var labelsLayer = new AMap.LabelsLayer({
        zooms: [3, 20],
        zIndex: 1000,
        collision: true,
        allowCollision: true,
      });
      map.add(labelsLayer);
      let find = orglist.subOrganizationsDTOes.find(data => data.id == localStorage.getItem("organization_id"));
      let parentDepth = find.depth;
      localStorage.setItem('currentDepth',parentDepth);
      orglist.subOrganizationsDTOes.forEach(async (val: any, idx: any, arr: any) => {
        var icon = {
          type: "image",
          image: "static/mapLogo.png",
          anchor: "center",
        };
        if (val.id == localStorage.getItem("organization_id")){
          icon.image = "static/mapLogo1.png"
        }else if (val.depth - parentDepth == 1){
          icon.image = "static/mapLogo2.png"
        }else if (val.depth - parentDepth == 2){
          icon.image = "static/mapLogo3.png"
        }else {
          icon.image = "static/mapLogo4.png"
        }

        var selector1 = {
          OrganizationId: val.id,
          user_id: parseInt(<string>localStorage.getItem("user_id")),
        }
        var temp = {
          level:'0',
          number: 0,
          ongoing_num: 0,
          paused_num: 0,
          completed_num: 0,
          completed_num_rate: 0
        }
        const projectInfoList = await javaapi.list({ entity: "project", interface: "getProjectsInfByOrganizationId" }, selector1);
        temp.number = projectInfoList.projectDTOes.length;
        projectInfoList.projectDTOes.forEach((val: any, idx: any, arr: any) => {
          if(val.level !== 'Z'){
            temp.level = val.level > temp.level?val.level:temp.level
          }
          //console.log(val)
          if (val.status == "进行中") {
            temp.ongoing_num++;
          } else if (val.status == "已暂停") {
            temp.paused_num++;
          } else if(val.status == "已完成"){
            temp.completed_num++;
          }
          if (temp.completed_num == 0) {
            temp.completed_num_rate = 0;
          } else {
            temp.completed_num_rate = Number.parseFloat((temp.completed_num / temp.number * 100).toFixed(0));
          }
        })
        var tempDate = {
          id: val.id,
          name: val.OrganizationName,
          rate: temp.completed_num_rate
        }
        var labelMarker = new AMap.LabelMarker({
          name: "标注2321321312",
          position: [Number(val.longitude), Number(val.latitude)],
          zIndex: 16,
          icon: icon,
          extData: tempDate,
        });
        infoWindow = new AMap.InfoWindow({ isCustom: true, offset: new AMap.Pixel(450, 150) });
        //根据info的内容获取机构的相关信息，显示在content中
        labelMarker.content = '<svg width="615" height="380" opacity="1">\
          <circle cx="15" cy="230" r="14" stroke="#2D5BD9" stroke-width="1" fill="none" />\
          <circle cx="15" cy="230" r="6.5" fill="#2D5BD9" />\
          <polyline points="15,216 15,176 73,126" style="fill:none;stroke:#2D5BD9;stroke-width:1" />\
          <polygon points="73,0 73,380 294,380 304,370 404,370 414,380 615,380 615,0 415,0 405,10 283,10 273,0"\
              style="fill:rgba(13,54,168,0.5);stroke:#0E9CFF;stroke-width:1px" />\
        </svg>\
        <div style="font-size:2.5vh;position: absolute;z-index: 100;top: 40px;left: 100px;">'+ val.OrganizationName + '</div>\
        <div id="main12" style="width: 200px;height:200px;position: absolute;z-index: 99;top: 70px;left: 60px;">\
        </div>\
        <div style="font-size:20px;position: absolute;z-index: 99;top: 240px;left: 113px;">项目完成率</div>\
        <div id="labelButton" style="background:rgba(18,40,149);z-index:999;width: 220px;height: 44px;border:0;border-radius: 22px;\
        position: absolute;top: 300px;right: 150px;display: flex;align-items:center;justify-content: center;">\
          <span style="cursor:pointer;">查看机构所有项目</span>\
        </div>\
        <div style="position: absolute;z-index: 99;top: 130px;left: 300px;">\
          <div style="font-size:20px;">项目总数</div>\
          <div style="font-size:44px;">'+ temp.number + '</div>\
          <div style="display: flex;">\
            <span style="padding-right: 10px;">进行中\
              <div>'+ temp.ongoing_num + '</div>\
            </span>\
            <span style="padding-right: 10px;">暂停中\
              <div>'+ temp.paused_num + '</div>\
            </span>\
            <span>已完成\
              <div>'+ temp.completed_num + '</div>\
            </span>\
          </div>\
        </div>';
        labelMarker.on('click', createInfoWindow);
        var text = new AMap.Text({
          position: [Number(val.longitude), Number(val.latitude)],
          anchor: "button-left",
          offset: [30, -20],
          text: val.OrganizationName,
          style: {
            "font-size": "3vh",
            color: "#fff",
            "font-family": "YouSheBiaoTiHei",
            "background-color": "transparent",
            border: "0px",
          },
        });
        text.on('click', createInfoWindow);
        map.add(text);
        if(temp.level !== '0'){
          var levelText = new AMap.Text({
          position: [Number(val.longitude), Number(val.latitude)],
          anchor: "button-left",
          offset: [30, 10],
          text: '评级'+ temp.level,
          style: {
            "font-size": "2vh",
            color: "#fff",
            "font-family": "PingFang SC-Semibold, PingFang SC",
            "background-color": "transparent",
            border: "0px",
            background: "linear-gradient(180deg, #FFF871 0%, #FF7B2E 100%)",
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
          },
        });
        map.add(levelText);
        }

        labelsLayer.add(labelMarker);
      });
      map.on('click', closeInfoWindow);
    })
    .catch((e) => {
      //console.log(e);
    });
};

const createInfoWindow = (e: { target: { content: any; getPosition: () => any; getOptions: () => any }; }) => {
  infoWindow.setContent(e.target.content);
  infoWindow.open(map, e.target.getPosition());
  lastPosition = e.target.getPosition();
  init(e.target.getOptions().extData.rate);
  var labelButton = document.getElementById("labelButton");
  if (labelButton) {
    labelButton.onclick = async function () {
      router.push({
        name: 'DistrictChart',
        query: {
          id: e.target.getOptions().extData.id,
          name: e.target.getOptions().extData.name,
        }
      });
    }
  }
};

const closeInfoWindow = () => {
  infoWindow.close(map, lastPosition);
}

onMounted(() => {
  initMap();
});
// onActivated(() => {
//   console.log("调用激活")
//   initMap();
// });
// watch(
//   () => route.path,
//   (newVal, oldVal) => {
//     console.log(newVal,oldVal,"====")
//     if(oldVal == '/user/institution/gis' ){
//       initMap();
//     }
//   }
  
// )

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", {
      class: "border-box",
      onClick: clickChart
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(organization_name.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 14,
                style: {"font-size":"min(2.5vh,1.375vw)"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createVNode(_component_el_row, {
                    gutter: 10,
                    style: {"font-size":"min(3.4vh,1.87vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(projectInfo.value[0].number), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("进行中")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已暂停")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已完成")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[0].ongoing_num), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[0].paused_num), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[0].completed_num), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(gauge, {
                    chartId: "gauge1",
                    px: px.value,
                    percentage: Number.parseFloat(projectInfo.value[0].completed_num_rate.toFixed(0))
                  }, null, 8, ["px", "percentage"]),
                  _createElementVNode("div", {
                    style: _normalizeStyle('width:'+px.value+'px;font-size:'+px.value/5+'px;text-align: center;')
                  }, "项目完成率", 4)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 14,
                style: {"font-size":"min(2.5vh,1.375vw)"}
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_el_row, {
                    gutter: 10,
                    style: {"font-size":"min(3.4vh,1.87vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(projectInfo.value[1].number), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("进行中")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已暂停")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已完成")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[1].ongoing_num), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[1].paused_num), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[1].completed_num), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(gauge, {
                    chartId: "gauge2",
                    px: px.value,
                    percentage: Number.parseFloat(projectInfo.value[1].completed_num_rate.toFixed(0))
                  }, null, 8, ["px", "percentage"]),
                  _createElementVNode("div", {
                    style: _normalizeStyle('width:'+px.value+'px;font-size:'+px.value/5+'px;text-align: center;')
                  }, "项目完成率", 4)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 14,
                style: {"font-size":"min(2.5vh,1.375vw)"}
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _createVNode(_component_el_row, {
                    gutter: 10,
                    style: {"font-size":"min(3.4vh,1.87vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(projectInfo.value[2].number), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("进行中")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已暂停")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已完成")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[2].ongoing_num), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[2].paused_num), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"min(2.3vh,1.265vw)","font-family":"DIN Alternate-Bold, DIN Alternate"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(projectInfo.value[2].completed_num), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(gauge, {
                    chartId: "gauge3",
                    px: px.value,
                    style: {"left":"50%"},
                    percentage: Number.parseFloat(projectInfo.value[2].completed_num_rate.toFixed(0))
                  }, null, 8, ["px", "percentage"]),
                  _createElementVNode("div", {
                    style: _normalizeStyle('width:'+px.value+'px;font-size:'+px.value/5+'px;text-align: center;')
                  }, "项目完成率", 4)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}
}

})